import { BulkUploadImportError, BulkUploadState } from './BulkUploadState';
import {
    BULKUPLOAD_CLEAR_IMPORT_ERRORS_TYPE,
    BULKUPLOAD_PROGRESS_TYPE
} from '../../actions/bulkUpload/bulkUploadActionType';

const initialState: BulkUploadState = {
    event: '',
    errors: 0,
    percentage: 0,
    record_number: 0,
    successfully_imported: 0,
    total_records: 0,
    import_errors: []
};

const nextImportErrors = (current: Array<BulkUploadImportError>, payload: any): Array<BulkUploadImportError> => {
    if (payload.event !== 'import_error' || !payload.error_details) {
        return current;
    }

    const isRepeated = current.some(
        importError =>
            importError.record_number === payload.record_number && importError.error_details === payload.error_details
    );

    // Channel events can arrive out of order, so keep the list sorted by record
    return isRepeated
        ? current
        : [...current, { record_number: payload.record_number, error_details: payload.error_details }].sort(
              (a, b) => a.record_number - b.record_number
          );
};

export const bulkUploadReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case BULKUPLOAD_PROGRESS_TYPE:
            return {
                ...state,
                event: action.payload.event,
                errors: action.payload.errors,
                percentage: action.payload.percentage,
                record_number: action.payload.record_number,
                successfully_imported: action.payload.successfully_imported,
                total_records: action.payload.total_records,
                import_errors: nextImportErrors(state.import_errors, action.payload)
            };
        case BULKUPLOAD_CLEAR_IMPORT_ERRORS_TYPE:
            return {
                ...state,
                import_errors: []
            };
        default:
            return state;
    }
};

export default bulkUploadReducer;
